import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { Box, Flex, Text } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import { CheckCircle } from "sprout-ui-icons";
import { colorMap } from "@sprout/client-lib/dist/labels_next";
const visuallyHiddenStyle = {
    border: "0px",
    clip: "rect(0px, 0px, 0px, 0px)",
    height: "1px",
    width: "1px",
    margin: "-1px",
    padding: "0",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
};
const StyledBox = styled(Box)`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 8px;
  justify-content: center;

  ${media.up("medium")} {
    grid-template-columns: 1fr 1fr;
  }
`;
const StyledFlex = styled(Flex)`
  cursor: pointer;
`;
const StyledText = styled(Text)`
  font-variant: tabular-nums;
`;
const PaymentPageFormPlans = (props)=>{
    const { plans , value , onChange  } = props;
    return /*#__PURE__*/ _jsx(StyledBox, {
        children: plans.map((plan)=>{
            const { amount , discount , unit , plan_duration  } = plan;
            const checked = plan_duration === value;
            return /*#__PURE__*/ _jsxs(Box, {
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        id: plan_duration,
                        onChange: onChange,
                        type: "radio",
                        style: visuallyHiddenStyle,
                        value: plan_duration,
                        checked: checked
                    }),
                    /*#__PURE__*/ _jsxs(StyledFlex, {
                        as: "label",
                        p: 2,
                        borderRadius: "8px",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        borderColor: checked ? "blue.500" : "black.12",
                        htmlFor: plan_duration,
                        children: [
                            checked ? /*#__PURE__*/ _jsx(Flex, {
                                as: "span",
                                color: "blue.500",
                                children: /*#__PURE__*/ _jsx(CheckCircle, {})
                            }) : /*#__PURE__*/ _jsx(Box, {
                                m: "2px",
                                as: "span",
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                borderWidth: "2px",
                                borderStyle: "solid",
                                borderColor: "black.87"
                            }),
                            /*#__PURE__*/ _jsxs(Box, {
                                ml: 2,
                                children: [
                                    /*#__PURE__*/ _jsxs(Flex, {
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ _jsx(StyledText, {
                                                fontSize: 3,
                                                fontWeight: "bold",
                                                children: `$${amount}`
                                            }),
                                            discount && /*#__PURE__*/ _jsx(Flex, {
                                                height: "24px",
                                                alignItems: "center",
                                                borderRadius: "30px",
                                                as: "span",
                                                ml: 2,
                                                bg: colorMap.green,
                                                px: 1,
                                                children: /*#__PURE__*/ _jsx(Text, {
                                                    as: "span",
                                                    color: "white.100",
                                                    fontSize: 1,
                                                    fontWeight: "bold",
                                                    children: `Save ${discount}%`
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        mt: 1,
                                        children: unit
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, plan_duration);
        })
    });
};
export default PaymentPageFormPlans;
